// import lazyLoading from './LazyLoading'
import MainLayout from '../components/main/MainLayout'

export default {
  path: '/main',
  component: MainLayout,
  meta: {
    title: 'Photographers101',
    login: false,
    loginType: 'user'
  }
}
